import {AnimationEasing, createEasingFunction} from "./easing";
import {lerp} from "./math";

export interface IKeyframeTrack {
    values: number[];
    times: number[];
    ease: AnimationEasing | AnimationEasing[];
}

const isSingleEasing = (ease: AnimationEasing | AnimationEasing[]): ease is AnimationEasing => ease === "linear" || typeof ease[0] === "number";

export const createTrackSampler = (track: IKeyframeTrack): ((time: number) => number) => {
    const {values, times, ease} = track;
    const segmentEasings = values.slice(0, -1).map((_, index) => createEasingFunction(isSingleEasing(ease) ? ease : ease[index]));

    return (time) => {
        const last = times.length - 1;

        if (time <= times[0]) {
            return values[0];
        }

        if (time >= times[last]) {
            return values[last];
        }

        let index = 0;

        while (time > times[index + 1]) {
            index++;
        }

        const span = times[index + 1] - times[index];
        const progress = span > 0 ? (time - times[index]) / span : 1;

        return lerp(values[index], values[index + 1], segmentEasings[index](progress));
    };
};

export const evaluateTrack = (track: IKeyframeTrack, time: number): number => createTrackSampler(track)(time);
import {AnimationEasing, createEasingFunction} from "./easing";
import {lerp} from "./math";

export interface IKeyframeTrack {
    values: number[];
    times: number[];
    ease: AnimationEasing | AnimationEasing[];
}

const isSingleEasing = (ease: AnimationEasing | AnimationEasing[]): ease is AnimationEasing => ease === "linear" || typeof ease[0] === "number";

export const createTrackSampler = (track: IKeyframeTrack): ((time: number) => number) => {
    const {values, times, ease} = track;
    const segmentEasings = values.slice(0, -1).map((_, index) => createEasingFunction(isSingleEasing(ease) ? ease : ease[index]));

    return (time) => {
        const last = times.length - 1;

        if (time <= times[0]) {
            return values[0];
        }

        if (time >= times[last]) {
            return values[last];
        }

        let index = 0;

        while (time > times[index + 1]) {
            index++;
        }

        const span = times[index + 1] - times[index];
        const progress = span > 0 ? (time - times[index]) / span : 1;

        return lerp(values[index], values[index + 1], segmentEasings[index](progress));
    };
};

export const evaluateTrack = (track: IKeyframeTrack, time: number): number => createTrackSampler(track)(time);
